import type { ActivityModule } from '../../core/activity';
import { runMemoryMathActivity, type MemoryMathLevelsFile } from '../../shared/memory-math-runner';
import levelsData from './levels.json';

const LEVELS = (levelsData as MemoryMathLevelsFile).levels;

export const memoryMathMinus: ActivityModule = {
  id: 'memory-math-minus',
  title: 'Memória — Subtração',
  description: 'Jogo da memória onde cada par é formado por uma expressão (ex: 8−3) e seu resultado (5). Treine a tabuada de subtração.',
  ageMin: 7,
  ageMax: 10,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/memory-math-minus/icon.svg',
  category: 'memoria',
  totalLevels: LEVELS.length,
  mount: (ctx) =>
    runMemoryMathActivity(ctx, {
      activityId: 'memory-math-minus',
      title: 'Memória — Subtração',
      hint: 'Encontre o par: expressão ↔ resultado.',
      levels: LEVELS,
    }),
};
